<template>
  <div class="my">
    <div class="top">
      <form action="/">
        <van-search
          v-model="approverForm.keyword"
          shape="round"
          background="#3f51b5"
          @search="changeItem"
          placeholder="搜索标题、申请人、编号"
        />
      </form>
      <van-dropdown-menu active-color="#1989fa">
        <van-dropdown-item
          v-model="approverForm.status"
          :options="status"
          @change="changeItem"
        />
        <van-dropdown-item
          v-model="approverForm.is_pay"
          :options="is_pay"
          @change="changeItem"
        />
      </van-dropdown-menu>
    </div>
    <div class="content">
      <van-row class="myapprover card" v-for="(item,index) in approval" :key="item.id">
        <van-col span="24" class="title"
          ><router-link :to="'/' + item.path + '/' + item.id">
          <span>({{index+1}})&nbsp;</span>{{
            item.title
          }}</router-link>
          <van-tag type="primary" v-if="item.process_status == 0"
            >待审核</van-tag
          >
          <van-tag type="success" v-if="item.process_status == 1"
            >已审核</van-tag
          >
          <van-tag type="danger" v-if="item.process_status == 2"
            >已驳回</van-tag
          >

          <van-tag
            type="primary"
            v-if="item.is_pay == 0"
            v-show="item.status == 1"
            >待付款</van-tag
          >
          <van-tag
            type="success"
            v-if="item.is_pay == 2"
            v-show="item.status == 1"
            >部分付款</van-tag
          >
          <van-tag
            type="success"
            v-if="item.is_pay == 1"
            v-show="item.status == 1"
            >已付款</van-tag
          >
        </van-col>
        <van-col span="24">编号：{{ item.no }}</van-col>
        <van-col span="24">申请人：{{ item.name }}</van-col>
        <van-col span="24">金额：{{ item.amount }}元</van-col>
        <van-col span="24">类型：{{ item.catalog_title }}</van-col>
        <van-col
          span="24"
          v-if="approverForm.status == 5 && item.is_pay != 1"
          style="text-align: center"
        >
          <!-- <van-button type="primary" @click="confirm_pay(item.id)" size="small">确认付款</van-button> -->
          <van-button type="primary" @click="openConfirm(item)" size="small"
            >确认付款</van-button
          >&nbsp;&nbsp;
          <van-button type="primary" @click="print(item)" size="small"
            >打印</van-button
          >
        </van-col>
        <van-col
          span="24"
          v-if="approverForm.status == 0"
          style="text-align: center"
        >
          <!-- <van-button type="primary" @click="confirm_pay(item.id)" size="small">确认付款</van-button> -->
          <van-button type="primary" @click="openApprove(item)" size="small"
            >审批通过</van-button
          >
        </van-col>

        <van-divider
          :style="{
            color: '#1989fa',
            borderColor: '#1989fa',
            padding: '15px 1px 0px 1px',
          }"
        />
      </van-row>
      <van-row v-if="total_amount">
        <van-col span="24">
          <div class='total_amount'>本页金额合计：{{page_total_amount.toLocaleString()}}元</div>
        </van-col>
        <van-col span="24">
          <div class='total_amount'>未审批金额合计：{{total_amount.toLocaleString()}}元</div>
        </van-col>
      </van-row>
      <van-row v-if="approverForm.last_page != 1">
        <van-col span="24">
          <van-pagination
            v-model="approverForm.current_page"
            :total="approverForm.total"
            :items-per-page="approverForm.per_page"
            :page-count="approverForm.last_page"
            @change="changePage"
          />
        </van-col>
      </van-row>
      
    </div>

    <!-- <van-row class="payment">
      
    </van-row> -->

    <Footer active="MyApproval"></Footer>
    <!-- 确认付款 -->
    <van-popup
      v-model="confirm_pay_show"
      closeable
      close-icon="close"
      round
      position="bottom"
      style="height: 42%; padding-top: 20px"
    >
      <van-form>
        <van-field
          v-model="confirm_pay_form.amount"
          name="总金额"
          label="总金额"
          disabled
        />
        <van-field
          v-model="confirm_pay_form.no_pay_amount"
          name="剩余金额"
          label="剩余金额"
          disabled
        />
        <van-field
          v-model="confirm_pay_form.pay_amount"
          type="number"
          name="付款金额"
          label="付款金额"
          placeholder="请输入付款金额"
          :rules="[{ required: true, message: '请填写付款金额' }]"
        />
        <van-field v-model="confirm_pay_form.payer_bank" label="付款账号"  required size='large' placeholder="请选择付款账号" @click="payer_bank.show=true" readonly is-link/>
        <van-action-sheet v-model="payer_bank.show" :actions="payer_bank.options" @select="payer_bank_onselect" />
        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            @click="confirm_pay()"
            >确认付款</van-button
          >
        </div>
      </van-form>
    </van-popup>
    <!-- 审核通过 -->
    <van-popup
      v-model="approve_show"
      closeable
      close-icon="close"
      round
      position="bottom"
      style="height: 35%; padding-top: 35px"
    >
      <van-form>
        <van-field
          class="comment"
          v-model="flowForm.comment"
          border
          placeholder="请填写审批意见……"
          left-icon="comment-circle-o"
          v-if="flowForm.flow_is_pre_cost == null"
        />
        <van-field
          v-else
          v-model="flowForm.comment"
          rows="2"
          label="审批意见："
          type="textarea"
          maxlength="50"
          placeholder="请输入审批意见……"
          show-word-limit
        />
        <div style="margin:30px 10px;text-align:center;" v-if="flowForm.flow_is_pre_cost == null">
          <!-- <span>类型：</span> -->
          <van-radio-group name="审批类型" v-model="flowForm.is_pre_cost" direction="horizontal">
            <span style="margin-right:10px;">审批类型：</span>
            <van-radio name="预付">预付</van-radio>
            <van-radio name="费用">费用</van-radio>
          </van-radio-group>

        </div>
        
        <div style="margin: 16px">
          <van-button
            round
            block
            type="primary"
            :loading="is_loading"
            @click="approve()"
            ><van-icon name="passed" />审批通过</van-button
          >
        </div>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "../../components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer,
  },
  data() {
    return {
      approval: [],
      active: 0,
      current_page: "",
      total_amount:'',
      approverForm: {
        keyword: "",
        status: 0,
        is_pay: "",

        current_page: 1,
        last_page: "",
        total: 15,
        per_page: 25,
      },
      status: [
        // { text: '所有审批', value: '' },
        { text: "待审核", value: 0 },
        { text: "已审核", value: 1 },
        { text: "已驳回", value: 2 },
        { text: "抄送我", value: 5 },
      ],
      is_pay: [
        { text: "所有审批", value: "" },
        { text: "已付款", value: 1 },
        { text: "部分付款", value: 2 },
        { text: "未付款", value: 0 },
      ],
      confirm_pay_show: false,
      confirm_pay_form: {
        amount: "",
        no_pay_amount: "",
        pay_amount: "",
        flow_id: "",
        payer_bank:'',
        payer_bank_id:'',
      },
      is_loading:false,
      approve_show: false,
      flowForm: {
        flow_id:"",
        comment: "",
        is_pre_cost:'',
        flow_is_pre_cost:'',
      },
      flow_id:'',
      payer_bank:{
        show:false,
        options:[],
      },
      // payer_bank_form:{
      //   pay_amount:this.flow.no_pay_amount,
      //   flow_id:this.$route.params.id,
      //   payer_bank:'',
      //   payer_bank_id:'',
      // }
    };
  },

  created() {
    // this.getCode();
    // console.log(this.$route.query)
    document.title = "我审批的";
    this.myapproval();
  },
  methods: {
    myapproval() {
      // this.approverForm.page = this.approverForm.current_page
      this.$http.post("my_approval", this.approverForm).then((res) => {
        console.log(res);
        if (res.data.code == 204) {
          this.$router.push({ name: "Login" });
          return false;
        }
        this.approval = res.data.data.flows.data;
        this.approverForm.current_page = res.data.data.flows.current_page;
        this.approverForm.total = res.data.data.flows.total;
        this.approverForm.per_page = res.data.data.flows.per_page;
        this.approverForm.last_page = res.data.data.flows.last_page;
        if(res.data.data.total_amount){
          this.total_amount = res.data.data.total_amount
        }
        
        // console.log(this.approverForm)
      });
    },
    changePage() {
      this.approverForm.page = this.approverForm.current_page;
      this.myapproval();
    },
    changeItem() {
      this.approverForm.page = 1;
      this.myapproval();
    },
    openConfirm(item) {
      console.log(item)
      this.confirm_pay_form.flow_id = item.id;
      this.confirm_pay_form.amount = item.amount;
      this.confirm_pay_form.no_pay_amount = item.no_pay_amount;
      this.confirm_pay_form.pay_amount = item.no_pay_amount;
      this.confirm_pay_show = true;
      this.getPayerBank(item);
    },
    openApprove(item){
      console.log(item)
      this.flowForm.flow_id = item.id;
      this.flowForm.flow_is_pre_cost = item.is_pre_cost
      this.approve_show = true;
    },
    //审批
    approve() {
      console.log(this.flowForm)
      // console.log(this.flowForm.is_pre_cost)
      // console.log(this.flowForm.flow_is_pre_cost)
      if((!this.flowForm.flow_is_pre_cost)&&(!this.flowForm.is_pre_cost)){
        if(this.confirm_pay_form.payer_bank_id==''){
          this.$dialog.alert({
              message: '请选择审批类型！',
            });
            return false;
        }
      }

      // return false;
      this.is_loading = true;
      this.$http.put("/flow/approve", this.flowForm).then((res) => {
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.$dialog
          .alert({
            message: res.data.msg,
          })
          .then(() => {
            // this.$router.push({ name: "MyApproval" });
            this.approve_show = false;
            this.is_loading = false;
            this.myapproval()
          });
      });
    },
    //确认付款
    confirm_pay() {
      // console.log(this.confirm_pay_form)
      // return false;
      if(this.confirm_pay_form.payer_bank_id==''){
        this.$dialog.alert({
            message: '请选择付款账号！',
          });
          return false;
      }
      this.$dialog
        .confirm({
          message: "确认付款" + this.confirm_pay_form.pay_amount + "元？",
        })
        .then((res) => {
          this.$http
            .post("flow/confirm_pay_amount", this.confirm_pay_form)
            .then((res) => {
              this.$dialog
                .alert({
                  message: res.data.msg,
                })
                .then((res) => {
                  location.reload();
                });
            });
        });
    },
    //打印
    print(item2) {
      console.log(item2.id)
      // this.flow_id = item2.id
      // console.log(this.flow_id)
      this.$router.push({
        name: "Print",
        params: {id: item2.id },
      });
    },
    // openConfirmPay(){
    //   this.confirm_pay_show = true
      
    // },
    //获取付款账号
    getPayerBank(flow){
      
      this.$http.post('payer_banks',flow)
      .then((res)=>{
        console.log(res)
        if (res.data.code != 200) {
          this.$dialog.alert({
            message: res.data.msg,
          });
          return false;
        }
        this.payer_bank.options = res.data.data.banks
        if(res.data.data.default_bank){
          var bank = res.data.data.default_bank
          this.confirm_pay_form.payer_bank = bank.bank_account+'/'+bank.bank
          this.confirm_pay_form.payer_bank_id = bank.id
        }
      })
    },
    payer_bank_onselect(item){
      this.payer_bank.show = false;
      this.confirm_pay_form.payer_bank = item.name;
      this.confirm_pay_form.payer_bank_id = item.id;
      // // this.payment.department = item.name;
      // this.approverForm.department_id = item.Id;
      // this.getApprover();

    },
  },
  computed:{
    page_total_amount(){
      var page_total = 0;
      this.approval.forEach((item)=>{
        page_total += item.amount
      })
      console.log(page_total)
      return page_total;
      
    }

  }
};
</script>
<style scoped>
.home {
  background: url(/images/home_bg.jpg) repeat-x;
}
.payment {
  margin: 0px 10px 100px 10px;
  padding-top: 10px;
}
.demo_nav {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 56px;
  background-color: #fff;
}
.demo-nav__title {
  font-weight: 600;
  font-size: 17px;
  text-transform: capitalize;
}
.demo-nav__back {
  position: absolute;
  top: 16px;
  left: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.van-cell__title {
  text-align: left;
}
.myapprover {
  text-align: left;
  margin: 0px 10px 0px 10px;
  line-height: 20px;
  padding: 0px;
  font-size: 12px;
}
.myapprover .title {
  font-size: 14px;
  line-height: 28px;
}
.my {
  margin-bottom: 140px;
}
.van-tag {
  margin: 0px 8px;
  padding: 5px;
}
.van-dropdown-menu {
  margin-bottom: 20px;
}
/* .card {
  margin:20px 5px;
  padding: 12px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 4px 4px #cccccc;

} */
.top {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;

  height: 60px;
  z-index: 99;
}
.content {
  margin-top: 120px;
}
.content a {
  color: hsl(210, 98%, 49%);
  font-weight: 600;
}
.content a:visited {
    color:#5c6bc0 !important;
}
.total_amount{
  font-size:16px;
  margin:10px auto;
  font-weight:bold;
  color:#07c160;
}
</style>
